module.exports = __webpack_public_path__ + "static/media/go-race-room.6dc5e532.png";